import {
  PremiumStatus,
  PremiumProduct,
} from '@hyphengroup/cms-components/types/car-insurance';
import { CarInsuranceContextState } from 'car-insurance/context';
import { fetchCarInsuranceBolttechDataWithPolling } from './utils';

export async function getSingsaverPremiumPrices(
  props: CarInsuranceContextState,
): Promise<{
  status: PremiumStatus;
  premiums: Array<PremiumProduct>;
}> {
  const {
    requestParams: {
      vehicle: { value: vehicleValue },
      ncd: { value: ncdValue },
      offenceFree: { value: offenceFreeValue },
      driver: { value: driverValue },
      offPeakVehicle: { value: offPeakVehicleValue },
    },
  } = props;

  return fetchCarInsuranceBolttechDataWithPolling({
    vehicle: vehicleValue,
    ncd: ncdValue ?? 0,
    // Below 30% NCD the driver is never eligible for the offence-free discount,
    // so the demerit-points question is hidden and 'N' is sent. From 30% up the
    // answer is inverted ("No demerit points" => eligible => 'Y'), defaulting to
    // 'Y' since the API rejects an empty value.
    offenceFree: (ncdValue ?? 0) >= 30 ? offenceFreeValue || 'Y' : 'N',
    offPeak: offPeakVehicleValue ?? '',
    noOfClaims: driverValue.numberOfClaims ?? 0,
    driver: driverValue,
  })
    .then((responce) => {
      return {
        status: responce.completed,
        premiums: responce.premiums,
      };
    })
    .catch((err) => {
      console.error('Polling for car insurance failed:', err);
      return {
        status: 'fail',
        premiums: [],
      };
    });
}
